class VolumeData {
    modelName;
    modelId;
    branchID;
    isHighlighted;
    isVisible;
    isTransparent;
    animationDuration;

    constructor(props) {
        this.modelId = props.modelId;
        this.branchID = props.branchId;
        this.modelName = modelManager.getModelNamebyModelId(this.modelId);
        this.isHighlighted = false;
        this.isVisible = true;
        this.isTransparent = false;
    }

    setHighlight(isHighlighted, animationDuration = 800) {
        this.isHighlighted = isHighlighted;
        this.animationDuration = (isServerLessTrainingUIMeeting() && wv.trainingAuthoringEnabled) ? 0 : animationDuration;
    }

    setVisibility(isVisible, animationDuration = 500) {
        this.isVisible = isVisible;
        this.animationDuration = animationDuration;
    }

    setTransparency(isTransparent, animationDuration = 500) {
        this.isTransparent = isTransparent;
        this.animationDuration = animationDuration;
    }

    defaultColor() {
        const model = getModelObject(this.modelId);
        if(!model || !model.geometry) {
            return undefined;
        }

        const color = model.geometry.attributes.color;
        const volume = modelManager.getVolume(this.branchID);
        const vertexStart = volume.start;
        return [...color.array.slice(vertexStart, vertexStart + 3)];
    }
}

export default VolumeData;
